import { useEffect, useRef, useState } from 'react';
import { Imagedownsize, Loading, refresh } from '../../components';
import {
  READ_DRAWBOOKGUEST, SEND_DRAWBOOKENTRY, SEND_DRAWBOOKUPLOADIMG,
  GET_PATHUPLOADTOKEN, UPDATE_PATHANDMSGENTRY, GET_IMGUPLOADTOKEN, UPDATE_IMGENTRY
} from '../../config/api';
import { iconwrapper } from '../../config/commonfunctions';
import { IMAGES_ICON } from '../../config/svgicons';
import { getOnePresignedUrlWithoutTokenWithLoad, notifyBackendUploadWithoutToken, uploadToS3, uploadToS3_withOctet } from '../../config/uploadimgapis';
import pako from 'pako'
import axios from 'axios'
import './Guestbook.css'
import { guestbook_doodle_strokewt } from '../../config/constants';

const _0_instruction_page = 0
const _1_drawing_page = 1
const _2_msg_and_path_send_page = 2
const _3_success_page = 3
const _4_add_img_option_page = 4
const _5_upload_img_page = 5
const _6_firework_and_remark_page = 6
const _7_redirect_page = 7

if (!crypto.randomUUID) {
  crypto.randomUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  };
}

function BaseSignIn(props) {
  const { bgcolor, uploaddata } = props
  const [sdkLoaded, setSdkLoaded] = useState(false);
  const [signinstate, setSigninstate] = useState(false);
  const scriptUrl = "https://unpkg.com/@base-org/account/dist/base-account.min.js";

  useEffect(() => {
    // If script already loaded, mark as ready
    if (window.createBaseAccountSDK) {
      setSdkLoaded(true);
      return;
    }

    // Check if script exists
    const existing = document.querySelector(`script[src="${scriptUrl}"]`);
    if (existing) {
      existing.addEventListener("load", () => setSdkLoaded(true));
      return;
    }

    // Create and load the script
    const script = document.createElement("script");
    script.src = scriptUrl;
    script.async = true;

    script.onload = () => {
      console.log("✅ Base Account SDK loaded");
      setSdkLoaded(true);
    };

    script.onerror = (err) => {
      console.error("❌ Failed to load Base Account SDK:", err);
      alert("Failed to load Base Account SDK. Please try again later.");
    };

    document.body.appendChild(script);

    // Cleanup
    return () => {
      script.remove();
    };
  }, []);

  // Helper: Safe nonce generator
  const generateNonce = () => {
    try {
      if (window.crypto?.randomUUID) {
        return window.crypto.randomUUID().replace(/-/g, "");
      } else if (window.crypto?.getRandomValues) {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11)
          .replace(/[018]/g, c =>
            (c ^ window.crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
          );
      }
    } catch (err) {
      console.warn("Nonce generation failed, fallback to timestamp:", err);
    }
    return Date.now().toString();
  };

  // Main handler to trigger the verification popup
  const handleSignIn = async () => {
    if (!window.createBaseAccountSDK) {
      alert("Base Account SDK not ready yet.");
      return;
    }

    try {
      const sdk = window.createBaseAccountSDK({
        appName: "WeaveBliss",
        appLogoUrl: "https://example.com/my-logo.png",
      });

      const provider = sdk.getProvider();
      const nonce = generateNonce();

      console.log("🪪 Requesting sign-in...");

      const response = await provider.request({
        method: "wallet_connect",
        params: [
          {
            version: "1",
            capabilities: {
              signInWithEthereum: {
                nonce,
                chainId: "0x2105", // Base Mainnet (8453)
              },
            },
          },
        ],
      });

      console.log("✅ Sign-in response:", response);
      setSigninstate(response.accounts?.[0]?.address.length > 0 ? true : false)
      alert(`Signed in as ${response.accounts?.[0]?.address || "unknown user"}`);
      if (response.accounts?.[0]?.address.length > 0 ? true : false) {
        uploaddata(response)
      }

    } catch (err) {
      console.error("❌ Sign-in failed:", err);
      alert(`Sign-in failed: ${err?.message || err}`);
    }
  };

  return !signinstate ?
    <button
      onClick={handleSignIn}
      disabled={!sdkLoaded}
      className='Drawbook_nextbtn' style={{ backgroundColor: bgcolor }}
    >
      {sdkLoaded ? "Sign In with Base" : "Loading..."}
    </button>
    : <div>signin</div>


  // return !signinstate ? (
  //   <div style={{ padding: 24 }}>
  //     <h1>Sign in with Base</h1>
  //     <p>
  //       {sdkLoaded ? "SDK ready ✅" : "Loading SDK..."}
  //     </p>
  //     <button
  //       onClick={handleSignIn}
  //       disabled={!sdkLoaded}
  //       style={{
  //         backgroundColor: sdkLoaded ? "#1E90FF" : "#aaa",
  //         color: "white",
  //         padding: "10px 20px",
  //         borderRadius: "8px",
  //         border: "none",
  //         cursor: sdkLoaded ? "pointer" : "not-allowed",
  //       }}
  //     >
  //       {sdkLoaded ? "Sign In with Base" : "Loading..."}
  //     </button>
  //   </div>
  // )
  //   : <div>signin</div>

}

function pointsToD_lowres(points, options = {}) {
  const {
    precision = 1,
    simplifyTolerance = 0,
    useSmartSimplify = true,
    useRdpSimplify = true,          // ✅ new: control RDP simplification
    rounding = false,
    filterDuplicates = true         // ✅ new: control skipping duplicate points
  } = options;

  if (!points || points.length === 0) return '';

  const round = (num) => +num.toFixed(precision);

  // --- RDP Simplification ---
  const getPerpendicularDistance = (pt, lineStart, lineEnd) => {
    const dx = lineEnd.x - lineStart.x;
    const dy = lineEnd.y - lineStart.y;
    if (dx === 0 && dy === 0) {
      return Math.hypot(pt.x - lineStart.x, pt.y - lineStart.y);
    }
    const t = ((pt.x - lineStart.x) * dx + (pt.y - lineStart.y) * dy) / (dx * dx + dy * dy);
    const nearestX = lineStart.x + t * dx;
    const nearestY = lineStart.y + t * dy;
    return Math.hypot(pt.x - nearestX, pt.y - nearestY);
  };

  const rdpSimplify = (pts, epsilon) => {
    if (pts.length < 3) return pts;

    let maxDist = 0;
    let index = 0;
    const end = pts.length - 1;

    for (let i = 1; i < end; i++) {
      const dist = getPerpendicularDistance(pts[i], pts[0], pts[end]);
      if (dist > maxDist) {
        index = i;
        maxDist = dist;
      }
    }

    if (maxDist > epsilon) {
      const left = rdpSimplify(pts.slice(0, index + 1), epsilon);
      const right = rdpSimplify(pts.slice(index), epsilon);
      return left.slice(0, -1).concat(right); // remove duplicate
    } else {
      return [pts[0], pts[end]];
    }
  };

  // --- Apply simplification if needed ---
  const simplified =
    useSmartSimplify && useRdpSimplify && simplifyTolerance > 0
      ? rdpSimplify(points, simplifyTolerance)
      : points;

  // --- Convert to SVG path string ---
  let d = '';
  let prev = null;

  simplified.forEach((pt, i) => {
    const x = rounding ? round(pt.x) : pt.x;
    const y = rounding ? round(pt.y) : pt.y;

    // Optional: filter exact duplicate points
    if (
      filterDuplicates &&
      prev &&
      prev.x === x &&
      prev.y === y
    ) {
      return;
    }

    d += (i === 0 ? 'M' : 'L') + x + ' ' + y;
    prev = { x, y };
  });

  return d;
}

function pointsToD(points, options = {}) {
  const {
    precision = 4,            // HIGH PRECISION
    simplifyTolerance = 0,     // NO SIMPLIFY
    useSmartSimplify = false,
    useRdpSimplify = false,
    rounding = false,          // KEEP RAW FLOATS
    filterDuplicates = true
  } = options;

  if (!points || points.length === 0) return '';

  const round = (num) => +num.toFixed(precision);

  let d = '';
  let prev = null;

  points.forEach((pt, i) => {
    const x = rounding ? round(pt.x) : pt.x;
    const y = rounding ? round(pt.y) : pt.y;

    if (filterDuplicates && prev && prev.x === x && prev.y === y) return;

    d += (i === 0 ? 'M' : 'L') + x + ' ' + y;
    prev = { x, y };
  });

  return d;
}



function Page1(props) {
  const { data, bgcolor, setGuestcryptodata, guestcryptodata, mode } = props
  const { guide, subtitle, title, type } = data
  const nextbtn_dom = <button className='Drawbook_nextbtn' style={{ backgroundColor: bgcolor }} onClick={() => { props.onNext() }}>Next</button>
  return <div className='Drawbook_page1'>
    <div className='Drawbook_page1content'>

      {{
        'ARC': <div
          style={{
            display: 'flex', placeContent: 'flex-start', position: 'relative', flexDirection: 'column',
            height: 150,
            width: 300,
          }}
        >
          <svg
            width={300}
            height={150}
            viewBox={"0 0 " + 300 + " " + 150}
          >
            <defs>
              <path
                id="topArc"
                fill="transparent"
                d={`
                    M 
                    ${title['style']['arc'].startX}, 
                    ${title['style']['arc'].startY} 
                    A 
                    ${title['style']['arc'].rx}, 
                    ${title['style']['arc'].ry} 
                    ${title['style']['arc']['x-axis-rotation']} 
                    ${title['style']['arc']['large-arc-flag']} 
                    ${title['style']['arc']['sweep-flag']} 
                    ${title['style']['arc'].endX}, 
                    ${title['style']['arc'].endY}
                    `}
              />
              <path
                id="bottomArc"
                d={`
                    M
                    ${subtitle['style']['arc'].startX},  
                    ${subtitle['style']['arc'].startY} 
                    A 
                    ${subtitle['style']['arc'].rx}, 
                    ${subtitle['style']['arc'].ry} 
                    ${subtitle['style']['arc']['x-axis-rotation']} 
                    ${subtitle['style']['arc']['large-arc-flag']} 
                    ${subtitle['style']['arc']['sweep-flag']} 
                    ${subtitle['style']['arc'].endX}, 
                    ${subtitle['style']['arc'].endY}
                `}
                fill="transparent"
              />
            </defs>

            <text
              fontSize={title['style']['arc'].fontSize}
              fill={title['style']['arc'].color}
              fontFamily={title['style']['arc'].fontFamily}
              style={{ cursor: 'pointer', width: title['style']['arc'].width }}
            >
              <textPath href="#topArc" startOffset="50%" textAnchor="middle">
                {title['text']}
              </textPath>
            </text>

            <text
              fontSize={subtitle['style']['arc'].fontSize}
              fill={subtitle['style']['arc'].color}
              fontFamily={subtitle['style']['arc'].fontFamily}
              style={{ cursor: 'pointer', width: subtitle['style']['arc'].width }}
            >
              <textPath href="#bottomArc" startOffset="50%" textAnchor="middle">
                {subtitle['text']}
              </textPath>
            </text>
          </svg>

        </div>,
        'TEXT': <div>text</div>,
      }[type]}

      <div style={{ display: 'flex', flexDirection: 'column', width: 300, height: 200, ...guide.style, fontSize: 16 }}>
        <div className='Drawbookedit_entrytext'>{guide['text1']}</div>
        <div className='Drawbookedit_entrytext'>{guide['text2']}</div>
        <div className='Drawbookedit_entrytext'>{guide['text3']}</div>
      </div>

      {/* cryptobool need to be true and domain have /crypto/_/_ so to allow base sign in */}
      {mode === 'BROADCASTNFT'
        ? guestcryptodata
          ? nextbtn_dom
          : <BaseSignIn bgcolor={bgcolor} goNext={props.onNext} uploaddata={(data) => { setGuestcryptodata(data) }} />
        : null}

      {mode === 'DEFAULT'
        ? nextbtn_dom
        : null}


    </div>
  </div>
}

function Page2(props) {

  const { data, bgcolor } = props
  const { colors } = data

  const canvasRef = useRef(null);
  const [paths, setPaths] = useState([]);
  const [color, setColor] = useState(null);

  const [drawingSize, setDrawingSize] = useState(0);

  const currentPath = useRef([]);
  const isDrawing = useRef(false);
  const lastPos = useRef({ x: 0, y: 0 });

  const animationFrameRef = useRef(null); // for cleanup

  const colorRef = useRef(color); // add this

  const loadTFfromCDN = () => {
    return new Promise((resolve, reject) => {
      // If TF already loaded, reuse it
      if (window.tf) {
        resolve(window.tf);
        return;
      }

      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/@tensorflow/tfjs@4.20.0/dist/tf.min.js";
      script.onload = () => resolve(window.tf);
      script.onerror = () => reject("Failed to load TensorFlow.js CDN");
      document.body.appendChild(script);
    });
  };

  useEffect(() => {
    if (colors.length > 0) {
      setColor(colors[0])
    }
    else {
      setColor('#000000')
    }

  }, [])

  useEffect(() => {
    colorRef.current = color; // update the current color whenever color state changes
  }, [color]);

  useEffect(() => {
    const canvas = canvasRef.current;
    canvas.width = 300;
    canvas.height = 300;
    const ctx = canvas.getContext('2d');

    const getPos = (e) => {
      const rect = canvas.getBoundingClientRect();
      if (e.touches) {
        return {
          x: e.touches[0].clientX - rect.left,
          y: e.touches[0].clientY - rect.top,
        };
      }
      else {
        return {
          x: e.clientX - rect.left,
          y: e.clientY - rect.top,
        };
      }
    };

    const updateDrawingSize = () => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      canvas.toBlob((blob) => {
        if (blob) {
          setDrawingSize((blob.size / 1024 / 1024).toFixed(2)); // size in MB
        }
      });
    };

    const start = (e) => {
      e.preventDefault();
      isDrawing.current = true;
      const pos = getPos(e);
      lastPos.current = pos;
      currentPath.current = [pos];
    };

    const draw = (e) => {
      if (!isDrawing.current) return;
      e.preventDefault();
      const pos = getPos(e);

      ctx.strokeStyle = colorRef.current; // use ref for latest color
      ctx.lineWidth = guestbook_doodle_strokewt;
      ctx.lineCap = 'round';

      ctx.beginPath();
      ctx.moveTo(lastPos.current.x, lastPos.current.y);
      ctx.lineTo(pos.x, pos.y);
      ctx.stroke();

      lastPos.current = pos;
      currentPath.current.push(pos);
    };

    const stop = () => {
      if (currentPath.current.length > 1) {
        setPaths((prev) => [...prev, { color: colorRef.current, points: [...currentPath.current] }]);
        updateDrawingSize(); // <--- add this line
      }
      currentPath.current = [];
      isDrawing.current = false;
    };

    canvas.addEventListener('mousedown', start);
    canvas.addEventListener('mousemove', draw);
    canvas.addEventListener('mouseup', stop);
    canvas.addEventListener('mouseleave', stop);

    canvas.addEventListener('touchstart', start, { passive: false });
    canvas.addEventListener('touchmove', draw, { passive: false });
    canvas.addEventListener('touchend', stop);
    canvas.addEventListener('touchcancel', stop);

    return () => {
      canvas.removeEventListener('mousedown', start);
      canvas.removeEventListener('mousemove', draw);
      canvas.removeEventListener('mouseup', stop);
      canvas.removeEventListener('mouseleave', stop);

      canvas.removeEventListener('touchstart', start);
      canvas.removeEventListener('touchmove', draw);
      canvas.removeEventListener('touchend', stop);
      canvas.removeEventListener('touchcancel', stop);

      cancelAnimationFrame(animationFrameRef.current);
    };
  }, []); // 👈 now empty dependency array so it's only set up once

  useEffect(() => {
    if (paths.length === 0) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  }, [paths]);

  return <div className='Drawbook_page1'>
    <div className='Drawbook_page1content'>

      <div style={{ height: 335 }}>

        <div className='Drawbook_page2row' style={{ width: 300 }}>

          <button
            className='Drawbook_backbtn'
            onClick={() => { props.onBack() }}
          >
            BACK
          </button>

          <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center', placeItems: 'center' }}>
            <div style={{ fontSize: 12, color: 'var(--maindark)', padding: '0px 5px' }}>{drawingSize}MB / 1MB</div>
            <button
              className='Drawbook_clearbtn'
              onClick={() => {
                const canvas = canvasRef.current;
                requestAnimationFrame(() => {
                  const ctx = canvasRef.current.getContext('2d');
                  ctx.clearRect(0, 0, canvas.width, canvas.height);
                  setDrawingSize(0); // reset
                });

                setPaths([]); // clear all saved paths
                currentPath.current = []; // clear current stroke

              }}
            >
              CLEAR
            </button>
          </div>

        </div>

        <canvas ref={canvasRef} className="drawbook-canvas" />

      </div>

      {/* <div className='Drawbook_colorpalette'> */}
      <div className='color-picker' style={{ width: 300, display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
        {colors.length === 0
          ? <button
            value={'#000000'}
            key={'#000000' + '_' + 0}
            onClick={() => { setColor('#000000'); }}
            style={{
              backgroundColor: '#000000',
              border: color === '#000000' ? '3px solid var(--subgrey)' : '3px solid transparent',
              touchAction: 'manipulation'
            }}
          />
          : colors.map((c, i) => {
            return <button
              value={c}
              key={c + '_' + i}
              onClick={() => { setColor(c) }}
              style={{
                backgroundColor: c,
                border: color === c ? '3px solid black' : '3px solid transparent',
                touchAction: 'manipulation'
              }}
            />
          })}

      </div>

      {parseInt(drawingSize) < 1 && paths.length > 0
        ? <button
          className={'Drawbook_nextbtn'}
          style={{ backgroundColor: bgcolor, marginTop: 30 }}
          onClick={() => {
            if (paths.length > 0) {
              props.onNext(paths)
            }
          }}

        // onClick={async () => {
        //   if (paths.length > 0) {
        //     const tf = await loadTFfromCDN();
        //     console.log("TFJS Loaded:", tf.version.tfjs);

        //     const canvas = canvasRef.current;

        //     // Preprocess canvas
        //     const tensor = tf.tidy(() => 
        //       tf.browser.fromPixels(canvas)
        //         .resizeBilinear([224, 224])
        //         .toFloat()
        //         .div(255.0)         // normalize
        //         .expandDims(0)
        //     );

        //     // Load model
        //     const model = await tf.loadGraphModel(
        //       'https://tfhub.dev/google/tfjs-model/imagenet/mobilenet_v2_140_224/classification/3/default/1',
        //       { fromTFHub: true }
        //     );

        //     // Run prediction
        //     const prediction = model.predict(tensor);

        //     // Convert tensor to data
        //     const data = prediction.dataSync(); // Float32Array of 1001 probabilities

        //     // Find index of highest probability
        //     const topIndex = data.indexOf(Math.max(...data));

        //     // Load ImageNet class labels
        //     const response = await fetch(
        //       'https://storage.googleapis.com/download.tensorflow.org/data/imagenet_class_index.json'
        //     );
        //     const imagenetClasses = await response.json();

        //     // Get class name
        //     const predictedClass = imagenetClasses[topIndex.toString()][1];

        //     console.log("Predicted class:", predictedClass);

        //     // Clean up tensor to free memory
        //     tf.dispose([tensor, prediction]);
        //   }
        // }}
        >
          Next
        </button>
        : parseInt(drawingSize) === 0 && data.drawguide[0].length === 0 && data.drawguide[1].length === 0
          ? <button
            className={'Drawbook_nextbtnblock'}
            style={{ backgroundColor: bgcolor, marginTop: 30 }}
          >
          </button>
          : null}

      {Number(drawingSize) > 1
        ? <button
          className={'Drawbook_nextbtn'}
          style={{ backgroundColor: bgcolor, marginTop: 30, color: 'white', backgroundColor: "var(--maindark)" }}
        >
          {`File limit exceeded (1 MB).`}
        </button>
        : null}

      {paths.length === 0 && data.drawguide[0].length > 0 && data.drawguide[1].length > 0
        ? <button
          className={'Drawbook_nextbtn'}
          style={{ backgroundColor: bgcolor, marginTop: 30 }}
          onClick={() => {
            window.open(data.drawguide[1])
          }}
        >
          {data.drawguide[0]}
        </button>
        : null}


    </div>
  </div>
}

function Page3(props) {
  const { data, bgcolor, updateMsg, updateName, onSend, blockgate } = props
  const [name, setName] = useState('')
  const [msg, setMsg] = useState('')

  return <div className='Drawbook_page1'>
    <div className='Drawbook_page1content'>
      <input
        placeholder={data['nameplaceholder']}
        className='Draw_input'
        style={{ width: 300, backgroundColor: bgcolor, border: '1px solid var(--maindark)' }}
        value={name}
        onChange={(e) => {
          setName(e.target.value);
          updateName(e.target.value)
        }}
      />
      <textarea
        className='Drawbook_textarearoot'
        // placeholder='Toast, roast, or advice — leave your mark!'
        placeholder={data['messageplaceholder']}
        style={{ height: 300, width: 300, backgroundColor: bgcolor, border: '1px solid var(--maindark)' }}
        value={msg}
        onChange={(e) => {
          let value = e.target.value

          // Limit to 300 characters
          if (value.length > 300) {
            value = value.slice(0, 300)
          }

          setMsg(value)
          updateMsg(value)
        }}
      />
      {/* <textarea
        className='Drawbook_textarearoot'
        placeholder='Toast, roast, or advice — leave your mark!'
        style={{ height: 300, width: 300, backgroundColor: bgcolor, border: '1px solid var(--maindark)' }}
        value={msg}
        onChange={(e) => {
          setMsg(e.target.value)
          updateMsg(e.target.value)
        }}
      /> */}
      <button
        disabled={blockgate}
        className={(msg.length > 0 && name.length > 0) ? 'Drawbook_nextbtn' : 'Drawbook_nextbtnblock'}
        style={{ backgroundColor: bgcolor, marginTop: 50 }}
        onClick={() => {
          if (msg.length > 0 && name.length > 0) {
            onSend()
          }
        }}
      >
        Send
      </button>

    </div>
  </div>
}

function Page5(props) {
  const { bgcolor, pagetext, onYes, onNo } = props

  return <div className='Drawbook_page1'>
    <div className='Drawbook_page1content'>
      <div style={{ display: 'flex', flexDirection: 'column', height: 390, placeContent: 'center', textAlign: 'center', placeItems: 'center' }}>
        <div style={{ fontSize: 16, whiteSpace: 'pre-wrap' }}>{pagetext}</div>
        <button
          className={'Drawbook_nextbtn'}
          style={{ backgroundColor: bgcolor, marginTop: 15 }}
          onClick={onYes}
        >
          Yes
        </button>
        <button
          className={'Drawbook_nextbtn'}
          style={{ backgroundColor: bgcolor, marginTop: 10 }}
          onClick={onNo}
        >
          No
        </button>
      </div>
    </div>
  </div>
}

function Page6(props) {
  const { onSend, bgcolor, blockgate } = props
  const [file, setFile] = useState(null);             // actual file
  const [preview, setPreview] = useState(null);       // preview image URL
  const [uploading, setUploading] = useState(false);  // loading state

  const imgref = useRef(null)
  const fileInputRef = useRef(null)


  const handleFileChange = (e) => {
    if (!e || !e.target || !e.target.files || e.target.files.length === 0) return;

    const selectedFile = e.target.files[0];
    setFile(selectedFile); // ✅ save actual file
    setPreview(URL.createObjectURL(selectedFile));
  };

  const handleSend = () => {
    if (!file) {
      alert("Please select an image.");
      return;
    }
    onSend(file); // onSend the file to parent
  };

  return <div className='Drawbook_page1'>
    <div className='Drawbook_page1content'>
      <div style={{ display: 'flex', flexDirection: 'column', height: 390, placeContent: 'center', textAlign: 'center' }}>


        <div style={{ height: 335 }}>
          <div className='Drawbook_page2row' style={{ width: 300 }}>
            <button
              className='Drawbook_backbtn'
              onClick={() => { props.onBack() }}
            >
              BACK
            </button>


          </div>
          <input
            ref={imgref}
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            style={{ height: 0, width: 0, }}
          />

          {preview
            ? <div className='Drawbook_imginput' onClick={() => imgref.current.click()} >
              <img src={preview} alt="Preview" width="100%" height="100%" style={{ objectFit: 'contain', backgroundColor: 'black' }} />
            </div>
            : <div className='Drawbook_imginput' onClick={() => imgref.current.click()}>
              {iconwrapper(IMAGES_ICON, { width: 45, height: 45, display: 'flex', placeContent: 'center' })}
            </div>}


        </div>
        <button
          className={'Drawbook_nextbtn'}
          disabled={blockgate}
          style={{ backgroundColor: bgcolor, marginTop: 10 }}
          onClick={handleSend}
        >
          {uploading ? 'Uploading...' : 'Upload'}
        </button>


      </div>
    </div>
  </div>
}

function Page7(props) {
  const { data, bgcolor } = props
  const [type, setType] = useState('') // LONG, SQUARE
  const [redirectbtns, setRedirectbtns] = useState([])
  const [title, setTitle] = useState('')
  useEffect(() => {
    const { redirectbtns, type, title } = data
    setRedirectbtns(redirectbtns)
    setType(type)
    setTitle(title)
  }, [data])
  return (
    <div className="Drawbook_page1">
      <div className="Drawbook_page1content" style={{ gap: 10 }}>
        <div style={{ fontSize: 16 }}>{title}</div>
        {redirectbtns.map((link, index) => {

          const label = link[0]; // Button text
          const url = link[1];   // Redirect URL

          if (label.length === 0 && url.length === 0) return
          if (url === 'NEWENTRY' && index === redirectbtns.length - 1) { // last one will always be redirect to the first page
            return <button
              key={index}
              className="Drawbook_nextbtn"
              style={{ backgroundColor: bgcolor, border: 'none' }}
              onClick={() => refresh()} // or use window.location.href = url
            >
              {label}
            </button>
          }

          return (
            <button
              key={index}
              className="Drawbook_nextbtn"
              style={{ backgroundColor: bgcolor }}
              onClick={() => window.open(url, '_blank')} // or use window.location.href = url
            >
              {label}
            </button>
          );

        })}
      </div>
    </div>
  );
}

function Pagesuccess(props) {
  const canvasRef = useRef(null);
  const [showText, setShowText] = useState(false);

  const colors = [
    '#FF69B4', '#FFB6C1', '#FFD1DC', '#F88379',
    '#FFA07A', '#FF1493', '#FFC0CB', '#FF85B3',
  ];

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const width = (canvas.width = window.innerWidth);
    const height = (canvas.height = window.innerHeight);
    const particleCount = 500;
    const centerX = width / 2;
    const centerY = height / 3;

    const particles = Array.from({ length: particleCount }, () => {
      const angle = Math.random() * 2 * Math.PI;
      const speed = Math.random() * 5 + 1;
      const size = Math.random() * 6 + 2;
      const color = colors[Math.floor(Math.random() * colors.length)];
      return {
        x: centerX,
        y: centerY,
        dx: Math.cos(angle) * speed,
        dy: Math.sin(angle) * speed,
        size,
        color,
        opacity: 1,
        life: 100,
      };
    });

    function draw() {
      ctx.clearRect(0, 0, width, height);
      particles.forEach(p => {
        ctx.globalAlpha = p.opacity;
        ctx.fillStyle = p.color;
        ctx.fillRect(p.x, p.y, p.size, p.size);
      });
      ctx.globalAlpha = 1;
    }

    function update() {
      particles.forEach(p => {
        p.x += p.dx;
        p.y += p.dy;
        p.dy += 0.1;
        p.life -= 1;
        p.opacity = Math.max(0, p.life / 100);
      });
    }

    function loop() {
      draw();
      update();
      if (particles.some(p => p.opacity > 0)) {
        requestAnimationFrame(loop);
      } else {
        ctx.clearRect(0, 0, width, height);
        setShowText(true);
      }
    }

    loop();
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      props.proceednext();
    }, props.timerend); // ✅ this should be a number (e.g., 3000 for 3s)

    return () => clearTimeout(timeout); // cleanup on unmount or dependency change
  }, [props.timer]); // ✅ run this effect when `props.timer` changes

  return (
    <div className="Drawbook_page1" style={{ position: 'relative', backgroundColor: props.bgcolor }}>
      <canvas
        ref={canvasRef}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          zIndex: 999,
          border: 'none',
          backgroundColor: props.bgcolor,
          fontSize: 16
        }}
      />
      {showText && (
        <div className='Drawbook_successtxt' >
          {props.pagetext}
        </div>
      )}
    </div>
  );
}

function Guestbook(props) {

  const [entryid, setEntryid] = useState(null) // will have the id after user submit drawing and msg, and this id will be use to send image
  // const [page, setPage] = useState(_0_instruction_page) // _0_instruction_page
  const [page, setPage] = useState(0) // _0_instruction_page
  const [mode, setMode] = useState('') // DEFAULT, BROADCASTNFT, DEFAULT_AND_BROADCASTNFT
  const [allowimgupload, setAllowimgupload] = useState(false)
  const [page1data, setPage1data] = useState(null)
  const [page2data, setPage2data] = useState(null)
  const [page3data, setPage3data] = useState(null)
  const [page4data, setPage4data] = useState(null)
  const [page5data, setPage5data] = useState(null)
  const [bgcolor, setBgcolor] = useState('')
  const [page2paths, setPage2paths] = useState([])
  const [page3msg, setPage3msg] = useState('')
  const [page3name, setPage3name] = useState('')
  const [page6data, setPage6data] = useState(null)
  const [page7data, setPage7data] = useState(null)
  const [guestcryptodata, setGuestcryptodata] = useState(null) // guest crypto data

  const [blockgate, setBlockgate] = useState(false)

  useEffect(() => {
    props.hidetopbar(true);
    const { urlhandler, passcode } = props.match.params
    axios({
      method: 'POST',
      url: READ_DRAWBOOKGUEST,
      data: { urlhandler, passcode }
    })
      .then((item) => {
        const { message, result } = item.data
        if (message === 'SUCCESS') {
          const { bgcolor, guestpages, allowimgupload, mode } = result
          setPage1data(JSON.parse(JSON.stringify(guestpages[0])))
          setPage2data(JSON.parse(JSON.stringify(guestpages[1])))
          setPage3data(JSON.parse(JSON.stringify(guestpages[2])))
          setPage4data(JSON.parse(JSON.stringify(guestpages[3])))
          setPage5data(JSON.parse(JSON.stringify(guestpages[4])))
          setPage6data(JSON.parse(JSON.stringify(guestpages[6])))
          setPage7data(JSON.parse(JSON.stringify(guestpages[7])))
          setBgcolor(bgcolor)
          setAllowimgupload(allowimgupload)
          setMode(mode)
        }
      })
      .catch((e) => {
        // props.history.push('/') 
      })
    return () => props.hidetopbar(false);
  }, [])


  return page1data
    ? <div className="drawbook-container" style={{ backgroundColor: bgcolor, height: '100vh', position: 'fixed', left: 0, top: 0 }}>
      {[

        // _0_instruction_page
        <Page1
          data={page1data}
          bgcolor={bgcolor}
          guestcryptodata={guestcryptodata}
          mode={mode}
          setGuestcryptodata={setGuestcryptodata}
          onNext={() => setPage(_1_drawing_page)}
        />,

        // _1_drawing_page
        <Page2
          data={page2data}
          bgcolor={bgcolor}
          onNext={(paths) => {
            setPage(_2_msg_and_path_send_page)

            const local_paths = paths.slice()

            if (false) {
              for (let i = 0; i < local_paths.length; i++) {

                // old
                // local_paths[i].points = pointsToD(local_paths[i].points, {
                //   precision: 6,            // Keeps two decimal places — smoother lines, the higher the decimal place the smoother
                //   simplifyTolerance: 0,    // Disables simplification completely
                //   useSmartSimplify: false,
                //   useRdpSimplify: false,
                //   rounding: false,
                //   filterDuplicates: false
                // });

                // new
                local_paths[i].points = pointsToD(local_paths[i].points, {
                  precision: 4,
                  rounding: false,
                  useSmartSimplify: false,
                  useRdpSimplify: false,
                  simplifyTolerance: 0,
                  filterDuplicates: true
                });

              }
            }

            setPage2paths(local_paths)

          }}
          onBack={() => setPage(_0_instruction_page)}
        />,

        // _2_msg_and_path_send_page
        <Page3
          data={page3data}
          bgcolor={bgcolor}
          page2paths={page2paths}
          blockgate={blockgate}
          updateMsg={(msg) => { setPage3msg(msg) }}
          updateName={(name) => { setPage3name(name) }}
          onSend={async () => {

            if (!blockgate) {
              setBlockgate(true)

              let walletaddr = ''

              if (mode === 'BROADCASTNFT') {
                const { accounts } = guestcryptodata
                try {
                  walletaddr = accounts[0]['address']
                }
                catch (e) {
                  walletaddr = ''
                }
              }


              const { urlhandler, passcode } = props.match.params;

              // Step 1: Stringify and gzip the paths
              const jsonPaths = JSON.stringify(page2paths);
              const compressed = pako.gzip(jsonPaths);

              const s3tokendata = await getOnePresignedUrlWithoutTokenWithLoad(GET_PATHUPLOADTOKEN, { urlhandler, passcode });
              if (s3tokendata.message === 'SUCCESS') {
                const { key, uploadURL, entryid } = s3tokendata
                await uploadToS3_withOctet(compressed, uploadURL);

                const { message } = await notifyBackendUploadWithoutToken({ urlhandler, passcode, page3msg, paths3url: key, name: page3name, msg: page3msg, entryid, walletaddr }, UPDATE_PATHANDMSGENTRY);

                if (message === "SUCCESS") {
                  setPage(_3_success_page)
                  setEntryid(entryid)
                }
                else { alert('Error, please refresh.') }
                setBlockgate(false)
              }
              else if (s3tokendata.message === 'REACH_MAX') {
                alert('Maximum Guest Entries Reached')
                setBlockgate(false)
              }
            }


          }}
        />,

        // _3_success_page
        <Pagesuccess
          bgcolor={bgcolor}
          pagetext={page4data ? page4data['messageplaceholder'] : ''}
          //   pagetext={`Sealed with love 💕
          // your message has made it to the guestbook!`}
          timerend={5000}
          proceednext={() => allowimgupload ? setPage(_4_add_img_option_page) : setPage(_7_redirect_page)}
        />,

        // _4_add_img_option_page
        <Page5
          bgcolor={bgcolor}
          // pagetext={`Would you also like to add an image to the guestbook?`}
          pagetext={page5data ? page5data['messageplaceholder'] : ''}
          onYes={() => { setPage(_5_upload_img_page) }}
          onNo={() => { setPage(_7_redirect_page) }}
        />,

        // _5_upload_img_page
        <Page6
          bgcolor={bgcolor}
          blockgate={blockgate}
          onSend={async (file) => {

            if (!blockgate) {
              setBlockgate(true)

              if (!file) return;

              const reader = new FileReader();

              reader.onload = async (e) => {
                const imgelem = document.createElement("img");

                imgelem.onload = async () => {
                  const { size } = file;

                  if (size < 20000000) { // 20MB
                    const [dataurl, downsizedBlob] = Imagedownsize(imgelem, 'scale', imgelem.width, imgelem.height);

                    const { urlhandler, passcode } = props.match.params;
                    const { key, uploadURL } = await getOnePresignedUrlWithoutTokenWithLoad(GET_IMGUPLOADTOKEN, { urlhandler, passcode, entryid });
                    await uploadToS3(downsizedBlob, uploadURL);
                    const { message } = await notifyBackendUploadWithoutToken({ urlhandler, passcode, imgs3url: key, entryid: entryid }, UPDATE_IMGENTRY);

                    if (message === "SUCCESS") {
                      setPage(_6_firework_and_remark_page)
                    } else {
                      alert("Error, please refresh.");
                    }
                    setBlockgate(false)
                  } else {
                    alert("File too large.");
                    setBlockgate(false)
                  }
                };

                imgelem.src = e.target.result;
              };

              reader.readAsDataURL(file); // ✅ must be called to trigger onload
            }
          }}

          onBack={() => { setPage(_4_add_img_option_page) }}
        />,

        // _6_firework_and_remark_page
        <Pagesuccess
          bgcolor={bgcolor}
          pagetext={page6data ? page6data['messageplaceholder'] : ''}
          // pagetext={`Thanks for sharing your love! 
          // ❤️ Your photo has been added to the guestbook.`}
          timerend={5000}
          proceednext={() => setPage(_7_redirect_page)}
        />,

        // _7_redirect_page
        <Page7
          bgcolor={bgcolor}
          data={page7data}
        />

      ][page]}
    </div>
    : <Loading />

}

export default Guestbook;
